// extracted by mini-css-extract-plugin
module.exports = {"initial":"viewSession_initial__2gEZF","descCard":"viewSession_descCard__y8HK2","text":"viewSession_text__WyVNT","header":"viewSession_header__oEw7J"};